// extracted by mini-css-extract-plugin
export default {"modal-body":"ModalBody_modal-body__1cLdu","body":"ModalBody_body__8qhDT","pseudo-sidebar":"ModalBody_pseudo-sidebar__3GUnZ","show-filters":"ModalBody_show-filters__qJctb"};